import { PartnerPanelContent } from '../partners/components/partner-panel-content/PartnerPanelContent';

export const PartnerPanel = () => {
    return <PartnerPanelContent />;
};
